
/* START_TEMPLATE */
define('hbs!pricelist/templates/formatMap2',['hbs','handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, stack2, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = depth0.info),stack1 == null || stack1 === false ? stack1 : stack1.Contact)),stack1 == null || stack1 === false ? stack1 : stack1.Title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")";
  return buffer;
  }

  buffer += "<div>\r\n    <img id=\"formatMapImage\" src=\"/Content/images/icon-check.png\">\r\n    <p id=\"formatMapLoading\" style=\"position: absolute; top: 110px; width:100%; text-align: center\">Laddar...</p>\r\n</div>\r\n<ul>\r\n    <li><strong>Format</strong><div class=\"format-info\">"
    + escapeExpression(((stack1 = ((stack1 = depth0.info),stack1 == null || stack1 === false ? stack1 : stack1.CreativeTypes)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</div></li>\r\n    <!--<li><strong>Devices:</strong><span>Desktop, Tablet</span></li>-->\r\n    <li><strong>Dimensioner</strong><div class=\"format-info\">"
    + escapeExpression(((stack1 = ((stack1 = depth0.info),stack1 == null || stack1 === false ? stack1 : stack1.Size)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</div></li>\r\n    <li><strong>Max storlek</strong><div class=\"format-info\">"
    + escapeExpression(((stack1 = ((stack1 = depth0.info),stack1 == null || stack1 === false ? stack1 : stack1.MaxWeight)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</div></li>\r\n    <li><strong>Filformat</strong><div class=\"format-info\">"
    + escapeExpression(((stack1 = ((stack1 = depth0.info),stack1 == null || stack1 === false ? stack1 : stack1.FileFormats)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</div></li>\r\n    <li><strong>Kontakt</strong><div class=\"format-info\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = depth0.info),stack1 == null || stack1 === false ? stack1 : stack1.Contact)),stack1 == null || stack1 === false ? stack1 : stack1.Email)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " ";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = depth0.info),stack1 == null || stack1 === false ? stack1 : stack1.Contact)),stack1 == null || stack1 === false ? stack1 : stack1.Title), {hash:{},inverse:self.noop,fn:self.program(1, program1, data)});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "</div></li>\r\n    <!--<li><strong>Pris:</strong><span>150 kr/CPM</span></li>-->\r\n</ul>\r\n";
  return buffer;
  });
Handlebars.registerPartial('pricelist_templates_formatMap2', t);
return t;
});
/* END_TEMPLATE */
;
